import PropTypes from 'prop-types';
import FJTitleLine from '../../../../common/combineComponents/FJTitleLine/FJTitleLine';
import FJAudioUpload from '../../../../common/combineComponents/FJAudioUpload/FJAudioUpload';
import FJMenuTab from '../../../../common/components/FJMenuTab/FJMenuTab';
import MicrophoneIcon from '../../../../assets/svg/microphone.svg?react';
import FJTextAreaWithLyric from '../../../../common/combineComponents/FJTextAreaWithLyric/FJTextAreaWithLyric';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJUtil from '../../../../util/FJUtil';

import styles from './FJAIAudioLeftM2M.module.less';

const FJAIAudioLeftM2M = ({
    subTabIndex,
    onChangeSubTab,
    // 歌声相关
    audioInfo,
    uploadAudioStatus,
    uploadAudioFile,
    clearAudioInfo,
    vocalAudioInfo,
    uploadVocalAudioStatus,
    uploadVocalAudioFile,
    clearVocalAudioInfo,
    onRecordClick,
    // 歌词相关
    lyricContent,
    onLyricContentChange,
    lyricDesc,
    onLyricDescChange,
    generateLyrics,
    isGenerateLyricsLoading,
    // 配乐相关
    incidentalAudioInfo,
    uploadIncidentalAudioStatus,
    uploadIncidentalAudioFile,
    clearIncidentalAudioInfo,
    isDraggingFile,
    setIsDraggingFile,
    isDraggingVoiceFile,
    setIsDraggingVoiceFile,
    // 其他功能
    onUseSampleInAudioFile,
    onUseSampleInVoiceFile,
    onUseSampleInIncidentalFile,
    openMediaLibraryByAudio,
    openMediaLibraryByVocalAudio,
    openMediaLibraryByIncidentalAudio,
}) => {
    const menuItems = [
        {
            text: FJLocalStore._('music-to-music'),
            value: 0,
        },
        {
            text: FJLocalStore._('music-to-instrumental'),
            value: 1,
        },
    ];

    const renderLyricsLength = () => {
        return <div className={styles.length}>{FJUtil.getByteLen(lyricContent)}/350</div>;
    };

    return (
        <div>
            <FJMenuTab list={menuItems} curIndex={subTabIndex} onChange={onChangeSubTab} />

            {subTabIndex === 0 && (
                <>
                    <FJTitleLine
                        title={FJLocalStore._('reference-music')}
                        desc={FJLocalStore._('please-upload-an-audio-containing-vocals-and-background-music')}
                        isRequire={true}
                        onUseSample={onUseSampleInAudioFile}
                        style={{ marginTop: 24 }}
                    />
                    <FJAudioUpload
                        uploadFile={uploadAudioFile}
                        audioInfo={audioInfo}
                        uploadStatus={uploadAudioStatus}
                        onDelete={clearAudioInfo}
                        isDraggingFile={isDraggingFile}
                        setIsDraggingFile={setIsDraggingFile}
                        openMediaLibrary={openMediaLibraryByAudio}
                    />
                    <FJTitleLine
                        title={FJLocalStore._('reference-vocal')}
                        desc={FJLocalStore._('please-upload-or-record-an-acapella-audio')}
                        onUseSample={onUseSampleInVoiceFile}
                    />
                    <div className={styles.content_box}>
                        <FJAudioUpload
                            uploadFile={uploadVocalAudioFile}
                            audioInfo={vocalAudioInfo}
                            uploadStatus={uploadVocalAudioStatus}
                            onDelete={clearVocalAudioInfo}
                            isDraggingFile={isDraggingVoiceFile}
                            setIsDraggingFile={setIsDraggingVoiceFile}
                            className={styles.box}
                            config={{ width: 250, height: 22 }}
                            uploadDesc={FJLocalStore._('upload-singing-voice')}
                            openMediaLibrary={openMediaLibraryByVocalAudio}
                        />
                        <div className={styles.record} onClick={onRecordClick}>
                            <MicrophoneIcon />
                        </div>
                    </div>
                    <FJTitleLine
                        title={FJLocalStore._('lyrics')}
                        desc={FJLocalStore._('you-can-use-line-breaks-to-separate-each-line-of-lyrics')}
                        isRequire={true}
                        isShowTry={false}
                        renderRight={renderLyricsLength}
                    />
                    <FJTextAreaWithLyric
                        placeholder={FJLocalStore._('textarea-placeholder')}
                        text={lyricContent}
                        onChange={onLyricContentChange}
                        onDescChange={onLyricDescChange}
                        descText={lyricDesc}
                        generateLyrics={generateLyrics}
                        isGenerateLyricsLoading={isGenerateLyricsLoading}
                    />
                </>
            )}

            {subTabIndex === 1 && (
                <>
                    <FJTitleLine
                        title={FJLocalStore._('reference-music')}
                        desc={FJLocalStore._('please-upload-an-audio-of-at-least-15s')}
                        isRequire={true}
                        onUseSample={onUseSampleInIncidentalFile}
                        style={{ marginTop: 24 }}
                    />
                    <FJAudioUpload
                        uploadFile={uploadIncidentalAudioFile}
                        audioInfo={incidentalAudioInfo}
                        uploadStatus={uploadIncidentalAudioStatus}
                        onDelete={clearIncidentalAudioInfo}
                        isDraggingFile={isDraggingFile}
                        setIsDraggingFile={setIsDraggingFile}
                        openMediaLibrary={openMediaLibraryByIncidentalAudio}
                    />
                </>
            )}
        </div>
    );
};

FJAIAudioLeftM2M.propTypes = {
    uploadFile: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
    uploadStatus: PropTypes.string,

    uploadAudioFile: PropTypes.func,
    audioInfo: PropTypes.object,
    uploadAudioStatus: PropTypes.string,
    uploadVocalAudioFile: PropTypes.func,
    vocalAudioInfo: PropTypes.object,
    uploadVocalAudioStatus: PropTypes.string,
    lyricContent: PropTypes.string,
    onLyricContentChange: PropTypes.func,
    onLyricDescChange: PropTypes.func,
    lyricDesc: PropTypes.string,

    clearAudioInfo: PropTypes.func,
    clearVocalAudioInfo: PropTypes.func,
    clearIncidentalAudioInfo: PropTypes.func,
    uploadIncidentalAudioFile: PropTypes.func,

    incidentalAudioInfo: PropTypes.object,
    uploadIncidentalAudioStatus: PropTypes.string,

    generateLyrics: PropTypes.func,
    isGenerateLyricsLoading: PropTypes.bool,

    isDraggingVoiceFile: PropTypes.bool,
    setIsDraggingVoiceFile: PropTypes.func,

    onRecordClick: PropTypes.func,
    onUseSampleInIncidentalFile: PropTypes.func,
    onUseSampleInAudioFile: PropTypes.func,
    onUseSampleInVoiceFile: PropTypes.func,

    openMediaLibraryByIncidentalAudio: PropTypes.func,
    openMediaLibraryByAudio: PropTypes.func,
    openMediaLibraryByVocalAudio: PropTypes.func,

    musicDuration: PropTypes.number,
    instrumentalDuration: PropTypes.number,
    onChangeMusicDuration: PropTypes.func,
    onChangeInstrumentalDuration: PropTypes.func,

    subTabIndex: PropTypes.number,
    onChangeSubTab: PropTypes.func,
};
export default FJAIAudioLeftM2M;
